var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-system-bar',{staticClass:"grey--text text--lighten-3",attrs:{"color":_vm.color}},[_c('v-icon',{staticClass:"ml-3 grey--text text--lighten-3"},[_vm._v(" "+_vm._s(_vm.icon)+" ")]),_c('span',{staticClass:"font-weight-bold ml-2"},[_vm._v(" "+_vm._s(_vm.$t(_vm.titleTag).toUpperCase())+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }